
import { defineComponent } from "vue";
import InfoSection from "../components/MainPage/InfoSection.vue";
import FinanceInfoSection from "../components/MainPage/FinanceInfoSection.vue";
import HeroSection from "../components/MainPage/HeroSection.vue";
import DealsSection from "@/components/MainPage/DealsSection.vue";
import ConnectionsSection from "@/components/MainPage/ConnectionsSection.vue";
import OpportunitiesSection from "@/components/MainPage/OpportunitiesSection.vue";
import OfficialSourcesSection from "@/components/MainPage/OfficialSourcesSection.vue";
import CompaniesStatsSection from "@/components/MainPage/CompaniesStatsSection.vue";
import ClientsStatsSection from "@/components/MainPage/ClientsStatsSection.vue";
import TargetSection from "@/components/MainPage/TargetSection.vue";
import BenefitsSection from "@/components/MainPage/BenefitsSection.vue";

export default defineComponent({
  name: "MainPage",
  components: {
    HeroSection,
    InfoSection,
    FinanceInfoSection,
    DealsSection,
    ConnectionsSection,
    OpportunitiesSection,
    TargetSection,
    BenefitsSection,
    ClientsStatsSection,
    CompaniesStatsSection,
    OfficialSourcesSection,
  },
});
